// Copyright (c) 2016 Deere & Company

import LaborStats, {getDefaultState as getLaborStatsDefaultState} from '../state/report';
import actions from '../../actions-list';

const updateLaborStatsReport = (state, action) =>
    LaborStats.update(state, {
        $set: action.data
    });

const resetLaborStatsReport = state =>
    LaborStats.update(state, {
        $set: getLaborStatsDefaultState()
    });

export default (state = getLaborStatsDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_LABOR_STATS_REPORT_SUCCESS]: updateLaborStatsReport,
        [actions.RESET_LABOR_STATS_REPORT]: resetLaborStatsReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/labor-stats/reducers/report.js